/***
*
*   LOGO
*   Replace the image in /images with your own logo
*
**********/

import React from 'react';
import { Link, ClassHelper } from 'components/lib';
import LogoWhite from './images/logo-white.svg';
import LogoMarkWhite from './images/logo-mark-white.svg';
import LogoColor from './images/logo-color.svg';
import LogoMarkColor from './images/logo-mark-color.svg';
import LogoTRS from './images/logo.png';
import Style from './logo.tailwind.js';

export function Logo(props){

  const logoStyle = ClassHelper(Style, props);
  
  // Solo aplicar estilos custom si se especifica
  const imageStyle = props.custom ? {
    width: props.size ? `${props.size}px` : 'auto',
    height: 'auto',
    maxWidth: 'none',
    maxHeight: 'none',
    transition: 'all 0.3s ease-out',
    userSelect: 'none',
    WebkitUserDrag: 'none'
  } : {
    userSelect: 'none',
    WebkitUserDrag: 'none'
  };
  
  return(
    <Link url='/' className={ logoStyle } ariaLabel='Ir al inicio' title='Ir al inicio'>
      <img src={ LogoTRS } alt='' aria-hidden='true' style={ imageStyle } draggable={ false } />
    </Link>
  )
}
